import Router, { useRouter } from 'next/router';
import { useState } from 'react';
import { useIsomorphicLayoutEffect } from 'react-use';

import { pathnameFromRouterUrl } from '~/utils/subscribeSubSideNavWidthSync';

export const useSubSideNavPathname = () => {
  const { asPath } = useRouter();
  const [nextPathname, setNextPathname] = useState<string | null>(null);

  // Width already opens on routeChangeStart; router.pathname stays on the old page until complete.
  useIsomorphicLayoutEffect(() => {
    const handleRouteChangeStart = (url: string) => {
      setNextPathname(pathnameFromRouterUrl(url));
    };
    const handleRouteChangeEnd = () => {
      setNextPathname(null);
    };

    Router.events.on('routeChangeStart', handleRouteChangeStart);
    Router.events.on('routeChangeComplete', handleRouteChangeEnd);
    Router.events.on('routeChangeError', handleRouteChangeEnd);

    return () => {
      Router.events.off('routeChangeStart', handleRouteChangeStart);
      Router.events.off('routeChangeComplete', handleRouteChangeEnd);
      Router.events.off('routeChangeError', handleRouteChangeEnd);
    };
  }, []);

  return { subSideNavPathname: nextPathname ?? pathnameFromRouterUrl(asPath) };
};
